var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 1.84131H9.01667C10.3233 1.84131 10.9767 1.84131 11.476 2.09564C11.915 2.31934 12.272 2.67628 12.4957 3.11531C12.75 3.61464 12.75 4.26797 12.75 5.57464V9.71631M4.11667 12.3413H8.84167C9.495 12.3413 9.82167 12.3413 10.0713 12.2141C10.2908 12.1023 10.4693 11.9238 10.5812 11.7043C10.7083 11.4546 10.7083 11.128 10.7083 10.4746V5.74964C10.7083 5.09631 10.7083 4.76964 10.5812 4.51998C10.4693 4.30046 10.2908 4.12199 10.0713 4.01014C9.82167 3.88298 9.495 3.88298 8.84167 3.88298H4.11667C3.46333 3.88298 3.13667 3.88298 2.887 4.01014C2.66749 4.12199 2.48902 4.30046 2.37717 4.51998C2.25 4.76964 2.25 5.09631 2.25 5.74964V10.4746C2.25 11.128 2.25 11.4546 2.37717 11.7043C2.48902 11.9238 2.66749 12.1023 2.887 12.2141C3.13667 12.3413 3.46333 12.3413 4.11667 12.3413Z",
    stroke: "#056EE6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyicon);
export default __webpack_public_path__ + "static/media/copyicon.5679747e1352b18a8e1ce8e670eae34b.svg";
export { ForwardRef as ReactComponent };